export default __webpack_public_path__ + "static/media/setting-icon.e33abff4.svg";